import { t } from 'i18next';
import { each, enforce, omitWhen, test } from 'vest';

import { FormUtils } from '@anyx/shared-utils';


import { ImageTypeBlock, UploadedImageFile } from '../types';
import { getManualActionURL, getVariableActionURL, isValidActionURL } from '../utils';

export const imagesValidationBuilder = (index: number) => (message: ImageTypeBlock) => {
  each(message.cards, (card, cardIndex) => {
    const prefix = `messages.${index}.cards.${cardIndex}`;

    test(
      `${prefix}.image`,
      FormUtils.requiredField(t('crm.lineMessageForm.fields.image.label', { ns: 'crm' })),
      () => {
        enforce(card.image).condition((image?: UploadedImageFile) => image?.state === 'remote');
      },
      `${prefix}-image`
    );

    omitWhen(card.actionUrl.status !== 'MANUAL', () => {
      test(
        `${prefix}.actionUrl.manual`,
        t('crm.lineMessageForm.validations.invalidUrl', { ns: 'crm' }),
        () => {
          enforce(getManualActionURL(card.actionUrl)).condition((url) => isValidActionURL(url));
        },
        `${prefix}-actionUrl-manual`
      );
    });

    omitWhen(card.actionUrl.status !== 'VARIABLE', () => {
      test(
        `${prefix}.actionUrl.variable`,
        FormUtils.requiredField(
          t('crm.lineMessageForm.fields.urlAction.variable.label', {
            ns: 'crm',
          })
        ),
        () => {
          enforce(getVariableActionURL(card.actionUrl)).isNotBlank();
        },
        `${prefix}-actionUrl-variable`
      );
    });
  });
};
